import PhoneInput from './react-phone-input-2-master/index';
import './react-phone-input-2-master/style.css';

export default PhoneInput;
